import { render, staticRenderFns } from "./Show-vacina.vue?vue&type=template&id=b891da62&scoped=true&"
import script from "./Show-vacina.vue?vue&type=script&lang=js&"
export * from "./Show-vacina.vue?vue&type=script&lang=js&"
import style0 from "./Show-vacina.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Show-vacina.vue?vue&type=style&index=1&id=b891da62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b891da62",
  null
  
)

export default component.exports